module.exports = __webpack_public_path__ + "img/P13_sandeep-brar.52539941.jpg";